import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-Duplicated-file',
  templateUrl: './Duplicated-file.component.html',
  styleUrls: ['./Duplicated-file.component.css']
})
export class DuplicatedFileComponent implements OnInit {
  FilesToReplace: any;


  constructor(
    public dialogRef: MatDialogRef<DuplicatedFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


  ngOnInit() {
    this.FilesToReplace = this.data.FilesToReplace
    for (let i = 0; i < this.FilesToReplace.length; i++) {
      const f = this.FilesToReplace[i];
      f.newName = f.name;
    }
  }

  ok(): void {
    this.dialogRef.close(this.FilesToReplace)
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
